<template>
<modal :name="name" :transition="transition" :scrollable="scrollable" :width="width" :height="height" @before-open="beforeOpen" @before-close="beforeClose" @opened="onOpened" @closed="onClosed">
    <slot />
</modal>
</template>

<script>
export default {
    props: {
        name: {
            type: String,
            required: true
        },
        transition: {
            type: String,
            default: "default"
        },
        scrollable: {
            type: Boolean,
            default: true
        },
        width: {
            type: String,
            default: "100%"
        },
        height: {
            type: String,
            default: "auto"
        },
        beforeOpen: {
            type: Function,
            default: function () {
                console.log('CustomModal.props.beforeOpen');
            }
        },
        beforeClose: {
            type: Function,
            default: function () {
                console.log('CustomModal.props.beforeClose');

            }
        },
        onOpened: {
            type: Function,
            default: function () {
                console.log('CustomModal.props.onOpened');
                $('body').css('overflow', 'hidden');
            }
        },
        onClosed: {
            type: Function,
            default: function () {
                console.log('CustomModal.props.onClosed');
                $('body').css('overflow', '');
            }
        }
    },
    beforeDestroy() {
        $('body').css('overflow', '');
    }
}
</script>

<style>
/* default transition style */
.default-enter-active,
.default-leave-active {
    transition: all 400ms;
}

.default-enter,
.default-leave-active {
    opacity: 0;
    transform: translateY(-20px);
}

/* slide transition style */
.slide-enter-active,
.slide-leave-active {
    transition: all 0.5s;
}

.slide-enter,
.slide-leave-active {
    opacity: 0;
    transform: translateX(100%);
}

/* scale transition style */
.scale-enter-active,
.scale-leave-active {
    transition: all 0.5s;
}

.scale-enter,
.scale-leave-active {
    opacity: 0;
    transform: scale(0.3) translateY(24px);
}
</style>



// WEBPACK FOOTER //
// src/components/common/CustomModal.vue